import { createAction } from 'redux-act';
// bulk Upload action
const bulkUploadRequest = createAction('BULK_UPLOAD_REQUEST', data => data);
const bulkUploadSuccess = createAction('BULK_UPLOAD_SUCCESS', data => data);
const bulkUploadError = createAction('BULK_UPLOAD_ERROR');

// bulk Upload action
const downloadBulkUploadSampleFileRequest = createAction('DOWNLOAD_BULK_UPLOAD_SAMPLE_FILE_REQUEST', data => data);
const downloadBulkUploadSampleFileSuccess = createAction('DOWNLOAD_BULK_UPLOAD_SAMPLE_FILE_SUCCESS', data => data);
const downloadBulkUploadSampleFileError = createAction('DOWNLOAD_BULK_UPLOAD_SAMPLE_FILE_ERROR');

// clear existing bulk Upload action
const handleClearBulkUploadStore = createAction('HANDLE_CLEAR_BULK_UPLOAD_STORE',data => data);

export default {
    bulkUploadRequest,
    bulkUploadSuccess,
    bulkUploadError,

    downloadBulkUploadSampleFileRequest,
    downloadBulkUploadSampleFileSuccess,
    downloadBulkUploadSampleFileError,
    
    handleClearBulkUploadStore,
}